import { render, staticRenderFns } from "./EventRequest.vue?vue&type=template&id=3e91889c&scoped=true"
import script from "./EventRequest.vue?vue&type=script&lang=js"
export * from "./EventRequest.vue?vue&type=script&lang=js"
import style0 from "./EventRequest.vue?vue&type=style&index=0&id=3e91889c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e91889c",
  null
  
)

export default component.exports